import { Link, useNavigate } from "react-router-dom";
import { Heart, ShoppingBag } from "lucide-react";
import { useCart } from "@/contexts/CartContext";
import { Button } from "@/components/ui/button";

export default function BookCard({ book, priority = false }) {
  const { add, toggleWishlist, isInWishlist } = useCart();
  const navigate = useNavigate();
  const promo = book.original_price && book.original_price > book.price;

  const buyNow = async () => {
    const ok = await add(book.id);
    if (ok) navigate("/panier");
  };

  return (
    <div data-testid={`book-card-${book.id}`} className="group relative">
      <div className="relative">
        <Link to={`/livre/${book.id}`}>
          <div className="aspect-[2/3] overflow-hidden bg-secondary/40 border border-border book-shadow book-cover-hover">
            <img
              src={book.cover_url}
              alt={book.title}
              loading={priority ? "eager" : "lazy"}
              className="w-full h-full object-cover"
            />
          </div>
        </Link>
        <div className="absolute top-3 left-3 flex flex-col gap-2">
          {book.is_new && (
            <span className="label-eyebrow bg-background/80 backdrop-blur px-2 py-1 border border-border">Nouveauté</span>
          )}
          {promo && (
            <span className="label-eyebrow bg-accent text-accent-foreground px-2 py-1">Promo</span>
          )}
        </div>
        <button
          data-testid={`wishlist-btn-${book.id}`}
          onClick={() => toggleWishlist(book.id)}
          className="absolute top-3 right-3 w-9 h-9 flex items-center justify-center rounded-full bg-background/80 backdrop-blur border border-border opacity-0 group-hover:opacity-100 transition-opacity"
          aria-label="Favori"
        >
          <Heart className={`w-4 h-4 ${isInWishlist(book.id) ? "fill-accent text-accent" : ""}`} />
        </button>
      </div>
      <div className="mt-4 space-y-1">
        <div className="label-eyebrow text-muted-foreground">{book.category}</div>
        <Link to={`/livre/${book.id}`} className="block">
          <h3 className="font-serif text-lg leading-tight tracking-tight hover:text-accent transition-colors">
            {book.title}
          </h3>
        </Link>
        <div className="text-xs text-muted-foreground">{book.author}</div>
        <div className="flex items-center justify-between pt-2">
          <div className="flex items-baseline gap-2">
            <span className="font-serif text-lg">{book.price.toFixed(2).replace(".", ",")} €</span>
            {promo && (
              <span className="text-xs text-muted-foreground line-through">{book.original_price.toFixed(2).replace(".", ",")} €</span>
            )}
          </div>
          <button
            data-testid={`add-cart-${book.id}`}
            onClick={() => add(book.id)}
            className="w-9 h-9 flex items-center justify-center border border-border hover:bg-accent hover:text-accent-foreground hover:border-accent transition-colors"
            aria-label="Ajouter au panier"
          >
            <ShoppingBag className="w-4 h-4" />
          </button>
        </div>
        <div className="flex gap-2 pt-3">
          <Button data-testid={`buy-now-${book.id}`} onClick={buyNow} size="sm" className="rounded-sm flex-1 h-9">
            Acheter maintenant
          </Button>
          <Link to={`/livre/${book.id}`} className="flex-1">
            <Button data-testid={`learn-more-${book.id}`} variant="outline" size="sm" className="rounded-sm w-full h-9">
              En savoir plus
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
